import { Injectable } from '@angular/core';
import { ModeModelBase, ModeModelInjectables } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ApiModel extends ModeModelBase {
  override _name = 'api';
  override hasMany = [{ name: 'dataSources', idAttribute: 'token' }];

  constructor(injectables: ModeModelInjectables) {
    super(injectables);
  }
}

@Injectable({ providedIn: 'root' })
export class ApiModelAccessor extends ModelAccessorBase<ApiModel> {
  override name: 'api';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.api');
  }

  createModel(resource, opts?) {
    const model = new ApiModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }

  override getIdFromLink = (link: string) => link.split('?')[0];
}
